<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
        <wcinput :option="{placeholder:'选择商品',clearable:true,ischange:true,width:'200px',isinput:true,iskeydown:true}" 
            :value="goodsinfo.name"
            @click="searchGoods"
            @finish="(val)=> {
                goodsinfo.name=val.value;
                param.ischange=true;
                GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcinput :option="{placeholder:'选择会员',clearable:true,ischange:true,width:'200px',isinput:true,iskeydown:true}" 
            :value="commentmember.name"
            @click="searchMember"
            @finish="(val)=> {
                commentmember.name=val.value;
                param.ischange=true;
                GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcinput :option="{placeholder:'评论内容',clearable:true,ischange:true,width:'200px',isinput:true,iskeydown:true,clearable:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item>
        <wcbutton 
            :option="{title:'重置',type:'del'}" 
            @finish="(val)=> {
                goodsinfo.id=0;
                goodsinfo.name='';
                commentmember.id=0;
                commentmember.name='';
                param.goodsid='';
                param.memberid='';
                param.key='';
                param.ischange=true;
                GetList();
            }"
        />
        </el-form-item>
    </el-form>
</div>


<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column label="评论商品" align="center">
            <template #default="scope">
                <wcimage :option="{size:'middle'}" :value="scope.row.goodsthumb" />
            </template>
        </el-table-column>
        <el-table-column label="商品名称" align="center">
            <template #default="scope">
                <div class="comment-goodsname" @click="$parent.JUMPVIEW({name:'EsGoodsDetail',param:{id:scope.row.goodsid}})">{{scope.row.goodsname}}</div>
            </template>
        </el-table-column>
        <el-table-column label="评论人" align="center">
            <template #default="scope">
                <div>{{scope.row.member_is_robot==2 ? scope.row.membername+'（'+scope.row.member_robotname+'）' : scope.row.membername}}</div>
            </template>
        </el-table-column>
        <el-table-column label="评论内容" align="center">
            <template #default="scope">
                <div class="content-box"><span v-if="scope.row.tomembername!=''">@{{scope.row.tomembername}}</span>{{scope.row.content}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="inputtime" label="评论时间" align="center"/>
        <el-table-column label="操作" align="center">
            <template #default="scope">
            <div class="TTL-btn-info">
                <wcbutton :option="{title:'删除',type:'del'}" @finish="delcomment(scope.row.id)" class="left10"/>
            </div>
            </template>
        </el-table-column>
        
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>



</template>

<script>
import INTERFACE_MODEL_GOODS from '@/Interface/Es/Goods/Goods';
export default {

    components:{
        
    },

    data() {
        return {
            objloading:'comment',
            param: {
                key:'',
                goodsid:'',
                memberid:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },

            list:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
            ],

            childhandleparam: {
                type:'',
                rollbackobjname:'',
                rollbackindex:'',
            },
            
            //选择商品操作
            goodsinfo: {
                id:'',
                name:'',
            },
            //选择会员操作
            commentmember: {
                id:'',
                name:''
            },

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                if(data.param.type=='selectgoods') {
                    this.goodsinfo.id=data.param.data.id;
                    this.goodsinfo.name=data.param.data.name;
                    this.param.goodsid=this.goodsinfo.id;
                    this.param.ischange=true;
                }else if(data.param.type=='selectmember') {
                    this.commentmember.id=data.param.data.id;
                    this.commentmember.name=data.param.data.name;
                    this.param.memberid=this.commentmember.id;
                    this.param.ischange=true;
                }
                this.GetList();
                
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetList();
            }

        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_GOODS.GET_GOODS_COMMENT(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },


        /** 删除商品信息 **/
        delcomment(id) {
            INTERFACE_MODEL_GOODS.DEL_COMMENT({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetList();
            });
        },

        
        /** 搜索商品 **/
        searchGoods() {
            this.$parent.JUMPVIEW({name:'EsGoods',param:{childtype:'selectgoods',rollbackobjname:'EsComment'}})
        },
        /** 搜索会员 **/
        searchMember() {
            this.$parent.JUMPVIEW({name:'EsMembers',param:{childtype:'selectmember',rollbackobjname:'EsComment'}})
        },

    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.ttl-finiss {display:inline-block;width:100%;text-align:center;font-size:13px;color:#666666;letter-spacing:1px;color:#666eeb}
.answer-name {font-style: normal;color:#666eeb;}
.goods-commont {display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;width:100%;}
.goods-commont-box {display:inline-flex;width:200px;padding:15px 0;font-size:0;}
.goods-commont-box .el-image {width:50px;height:50px;border-radius: 50%;display: inline-block;}
.goods-commont-content {display: inline-block;width:calc(100% - 50px - 15px);min-height: 50px;font-size:0;}
.goods-commont-name {display: inline-flex;align-items: center;width:100%;font-size:12px;line-height:18px;position:relative;}
.goods-commont-time {position:absolute;right:0;font-size:12px;}
.goods-commont-name i {font-style:normal;color:#999999}
.content {display: inline-block;margin-top:0;}
.membername {font-size:13px;color:#666eeb;}
.content-box {display: inline-block;width:100%;font-size:13px;}
.content-box span {color:#666eeb;margin-right:10px;}
.comment-goodsname {color: #666eeb;cursor: pointer;}
</style>